import humanizeDuration from 'humanize-duration'


export default (from,to, options={}) => {
    const currentLng = localStorage.getItem('ulty-lng')?.split('-')[0] || 'fr';
    const fromDate = new Date(from).getTime();
    const toDate = new Date(to).getTime();
    return humanizeDuration(parseInt(fromDate - toDate), { language: currentLng,fallbacks:['fr','en'],...options});
}